import React from 'react';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons/faSignInAlt';

import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';

const FormConvertBtn = (props) => {
  const {
    res, children, onClick = () => {},
    icon,
    disabled,
    ...rest
  } = props;
  const success = res.status === 'success';
  return (
    <FormHttpBtn
      className="btn-outline-primary mb-3 ml-3"
      icon={icon || faSignInAlt}
      onClick={onClick}
      res={res}
      type="button"
      disabled={success || disabled}
      {...{ rest }}>
      {success ? 'Completed' : children}
    </FormHttpBtn>
  );
};

export default FormConvertBtn;
